import { render, staticRenderFns } from "./EditSectionResponse.vue?vue&type=template&id=6d0b1534&"
import script from "./EditSectionResponse.vue?vue&type=script&lang=js&"
export * from "./EditSectionResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports